export default {
  siteTitle: "Epitaph | 墓志铭 - 萝北来信的作品与思想集",
  navItems: [
    { nameKey: "common.nav.home", path: "/" },
    { nameKey: "common.nav.celebration", path: "/celebration" },
    { nameKey: "common.nav.paintings", path: "/paintings" },
    { nameKey: "common.nav.photographs", path: "/photographs" },
    { nameKey: "common.nav.sounds", path: "/sounds" },
    { nameKey: "common.nav.about", path: "/about" }
  ]
} 